import axios from "axios";
import attributes from "../../models/atributos/attributes";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getAttributes() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/atributos/all`, { headers }).then(({ data }) => {
      return data.map((item) => {
        return attributes.fromJson(item);
      });
    });
  }

  addAttributes(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const getType = (type) => {
      switch (type) {
        case "Entero":
          return "I";
        case "Cadena":
          return "S";
        case "Lista":
          return "L";
      }
    };
    const payload = {
      nombre: data.name,
      descripcion: data.description,
      tipo: getType(data.type),
    };

    if (data.hasOwnProperty("values")) {
      payload.valores = data.values;
    }
    return axios.post(`${url}/atributos`, payload, { headers });
  }

  deleteAttribute(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/atributos/${id}`, { headers });
  }

  editAttribute(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {};

    const getType = (type) => {
      switch (type) {
        case "Entero":
          return "I";
        case "Cadena":
          return "S";
        case "Lista":
          return "L";
        default:
          return "";
      }
    };

    if (data.hasOwnProperty("name")) {
      payload.nombre = data.name;
    }
    if (data.hasOwnProperty("description")) {
      payload.descripcion = data.description;
    }
    if (data.hasOwnProperty("type")) {
      payload.tipo = getType(data.type);
    }
    if (data.hasOwnProperty("values")) {
      payload.valores = data.values;
    }

    return axios
      .patch(`${url}/atributos/${data.atribId}`, payload, {
        headers,
      })
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }
}
export default service;
